import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { LIVE_SESSIONS_TRANSLATION_KEY } from "../constants";
var pt = /*#__PURE__*/_defineProperty({}, LIVE_SESSIONS_TRANSLATION_KEY, {
  SEARCH_SESSION: 'Buscar sessão',
  CTA_UPDATE_SESSIONS_LIST: 'Atualizar',
  DATE_SESSIONS_HEADER_TODAY: 'Sessões para hoje',
  DATE_SESSIONS_HEADER_TOMORROW: 'Amanhã {{date}}',
  DATE_SESSIONS_CARD_GUESTS: '{{guests}} convidados',
  DATE_SESSIONS_CARD_GUESTS_plural: '{{guests}} convidados',
  NO_PAST_SESSIONS: 'Não há sessões passadas',
  NO_UPCOMING_SESSIONS: 'Você não tem nenhuma sessão criada',
  NO_UPCOMING_SESSIONS_DESCRIPTION: 'Comece a criar ambientes de aprendizado dinâmicos para seus colaboradores',
  SESSION_CARD_CTA_DETAIL: 'Ver detalhes',
  SESSION_CARD_CTA_EDIT: 'Editar sessão',
  SESSION_CARD_CTA_ADD_USERS: 'Adicionar participantes',
  SESSION_CARD_CTA_ASSISTANCE: 'Adicionar suporte',
  SESSION_CARD_CTA_DELETE: 'Excluir sessão',
  SESSION_CARD_LINK_PLACEHOLDER: 'Evento virtual',
  NO_RESULTS_FOUND: 'Nenhum resultado encontrado',
  SESSION_START_IN: 'Sua sessão começa às {{min}} MIN',
  SESSION_LIVE_TAG: 'Ao vivo',
  ON_LIVE: 'Ao vivo',
  GET_INTO: 'Ingresar',
  SESSION_IN_PROGRESS: 'No curso',
  NO_UPCOMING_SESSIONS_COLLABORATOR: 'Você não tem sessões agendadas no momento',
  NO_PAST_SESSIONS_COLLABORATOR: 'Você não tem sessões anteriores no momento',
  GUESTS_TABLE_TITLE: 'Participantes',
  GUESTS_TABLE_SUBTITLE: 'Aqui você pode ver todos os usuários da organização.',
  GUESTS_TABLE_SEARCH: 'Buscar por nome, sobrenome ou e-mail',
  GUESTS_TABLE_TOTAL_SELECTED_ACCEPT: 'selecionado nesta página.',
  GUESTS_TABLE_TOTAL_SELECTED_CANCEL: 'selecionados no total.',
  GUESTS_TABLE_FILTER: 'Filtrar por',
  GUESTS_TABLE_SELECT_ALL: 'Selecionar todos os {{total}} itens',
  GUESTS_TABLE_REMOVE_SELECTION: 'Remover seleção',
  GUESTS_TABLE_COLUMN_NAME: 'Nome',
  GUESTS_TABLE_COLUMN_MAIL: 'E-mail',
  GUESTS_TABLE_COLUMN_ATTRIBUTES: 'Atributos',
  DELETE_SESSION_DIALOG_TITLE: 'Deseja excluir {{sessionTitle}}?',
  DELETE_SESSION_DIALOG_SUBTITLE: 'Ao excluir a sessão, qualquer colaborador com o QR e/ou link, ao entrar, mostrará uma página de erro.',
  DELETE_SESSION_DIALOG_CANCEL: 'Cancelar',
  DELETE_SESSION_DIALOG_DELETE: 'Excluir',
  BLOCKED_SCREEN_DEVELOPMENT: 'Desenvolvimento',
  BLOCKED_SCREEN_TITLE: 'Crie atividades ao vivo com sua equipe',
  BLOCKED_SCREEN_SUBTITLE: 'Crie sessões ao vivo permitindo interação em tempo real para promover uma aprendizagem mais participativa',
  BLOCKED_SCREEN_DEMO_CTA: 'Solicitar demonstração gratuita',
  BLOCKED_SCREEN_DEMO_VIDEO: 'Ver vídeo',
  BLOCKED_SCREEN_CARDS_TITLE: 'O que você terá acesso?',
  BLOCKED_SCREEN_FIRST_CARD_TITLE: 'Agende sessões ao vivo',
  BLOCKED_SCREEN_FIRST_CARD_DESCRIPTION: 'Agende sessões presenciais ou virtuais, o convite será enviado por e-mail para seus usuários.',
  BLOCKED_SCREEN_SECOND_CARD_TITLE: 'Gravação da sessão',
  BLOCKED_SCREEN_SECOND_CARD_DESCRIPTION: 'Carregue a gravação e os arquivos complementares para sua sessão.',
  BLOCKED_SCREEN_THIRD_CARD_TITLE: 'Registro de presença',
  BLOCKED_SCREEN_THIRD_CARD_DESCRIPTION: 'Mantenha um registro das pessoas que participaram de sua sessão dentro da plataforma.',
  BLOCKED_SCREEN_DEMO_DIALOG_TITLE: 'Gostaria de solicitar uma demonstração gratuita do Elevate Plus?',
  BLOCKED_SCREEN_DEMO_DIALOG_SUBTITLE: 'Os recursos do Elevate LXP estão disponíveis no plano Elevate Plus. Solicite uma demonstração e atualize seu plano para começar a gerenciar seu próprio conteúdo.',
  BLOCKED_SCREEN_DEMO_DIALOG_CTA: 'Sim, solicitar',
  BLOCKED_SCREEN_DEMO_DIALOG_CANCEL: 'Cancelar',
  SESSIONS_LIST_ERROR_TITLE: 'Houve um erro ao carregar as sessões',
  SESSIONS_LIST_ERROR_SUBTITLE: 'Clique no botão para tentar carregar novamente.',
  SESSIONS_LIST_ERROR_CTA: 'Tentar novamente',
  NEW_LIVE_SESSION_TAG: 'Nova sessão',
  GUEST_CARD_TITLE: 'Participantes',
  GUEST_TABLE_NAME_COLUMN: 'Nome',
  GUEST_TABLE_CONFIRMATION_COLUMN: 'Confirmação',
  GUEST_TABLE_ACTIONS_COLUMN: 'Ações',
  GUEST_CARD_SEARCH: 'Buscar',
  GUEST_CARD_NO_GUEST_TITLE: 'Você ainda não adicionou participantes',
  GUEST_CARD_NO_GUEST_SUBTITLE: 'Lembre-se de fazê-lo para que possamos enviar as notificações',
  GUESTS_TABLE_ASSIST_CTA: 'Assistiram',
  GUEST_TABLE_ASSISTANCE_COLUMN: 'Assistência',
  TOOLTIP_CONFIRMED_PARTICIPANTS_COUNT: 'Confirmados',
  TOOLTIP_ADD_PARTICIPANTS_CTA: 'Adicionar participantes',
  TOOLTIP_INVITED_COUNT: 'Convidados',
  TOOLTIP_CANT_REMOVE_PARTICIPANT: 'Você não pode remover participantes confirmados',
  TOOLTIP_ASSIST_COUNT: 'Assistidos',
  TOOLTIP_ASSIST_BUTTON: 'Selecione quem participou para marcá-los como assistidos',
  TOOLTIP_NO_PRESENT_ACTION: 'Você deve marcar o usuário como presente para acessar mais ações',
  COPY_LINK: 'link de cópia',
  VIRTUAL: 'Virtual',
  PRESENTIAL: 'Presencial',
  SESSION_IN_COURSE_TAG: 'Sessão como aula',
  SEND_MESSAGE: 'Enviar mensagem',
  USER_SELECTION_PAGE_ALL: 'Selecionar todos os {{count}} itens',
  USER_SELECTION_PAGE: ' selecionados nesta página.',
  TOOLTIP_REMOVE_ASSISTANCE: 'Remover a assistência não é reversível. Se você fizer isso, precisará marcá-la manualmente.',
  DELETE_USER: 'Excluir participante'
});
export default pt;